var currentPlaylistId = null;
function initPlaylistSection(preselectId=0) {

    // Utente non loggato: stato vuoto stile Download (niente bottone crea,
    // niente chiamate API). La chiave NO_CONTENTS_SAVED può essere aggiunta
    // al dizionario traduzioni; finché manca usa il fallback inglese.
    if (typeof userData === 'undefined' || !userData || userData.status != 'success') {
        var noSavedText = translate('NO_CONTENTS_SAVED');
        if (noSavedText === 'NO_CONTENTS_SAVED') noSavedText = 'No saved contents';
        $('.playlistSection').html(`
            <div class='white text-center' style="margin-top:30vh;">
                <i class="ri-heart-line white" style="font-size:56px; opacity:0.5;"></i>
                <p>${noSavedText}</p>
            </div>
        `);
        $('.sectionContainer').hide();
        $('.searchHome').hide();
        $('.playlistSection').show();
        $('html').scrollTop(0);
        return;
    }

    // Tab orizzontali con i nomi delle playlist (niente più lista di righe
    // con i gradient): il tap sulla tab carica i contenuti qui sotto.
    $('.playlistSection').html(`
        <div id="mainPlaylist" class="">
            <div class="playlist-tabs" id="playlistTabs"></div>
            <div id="playlistInlineView"></div>
        </div>
    `);

    // Hide other sections and show the playlist section
    $('.sectionContainer').hide();
    $('.searchHome').hide();
    $('.playlistSection').show();
    $('html').scrollTop(0);

    getUserPlaylist().then(playlists => {
        let html = '';
        Object.entries(playlists).forEach(([index, playlist]) => {
            html += `<div class="playlist-tab" id="playlist-tab-${index}" onclick="selectPlaylistTab(${index});">${playlist.title}</div>`;
        });
        html += `<div class="playlist-tab playlist-tab-add" onclick="initCreatePlaylist();"><i class="ri-add-line"></i> ${translate('CREATE')}</div>`;
        $('#playlistTabs').html(html);

        if (!playlists[preselectId]) { preselectId = 0; }
        selectPlaylistTab(preselectId);
    });
}

function selectPlaylistTab(playlistId) {
    $('.playlist-tab').removeClass('active');
    $('#playlist-tab-' + playlistId).addClass('active');
    renderPlaylistInline(playlistId);
}

// contenuti della playlist selezionata, renderizzati sotto le tab
function renderPlaylistInline(playlistId) {
    if (!userData.playlists || !userData.playlists[playlistId]) { return; }
    currentPlaylistId = playlistId;

    $('#playlistInlineView').html(`
        <div class="playlist-inline-header">
            <h2 id="playlistCurrentTitleValue" class="white xbold"></h2>
            <div class="playlist-actions">
                <span class="dropdown playlistOptionMainDropdown">
                    <button class="button-round" onclick="openPlaylistSettings();">
                        <i class="ri-more-2-line"></i>
                    </button>
                </span>
                <button onclick="shareNowPlaylist();" style="display:none;" id="playlist-sharenow-btn" class="button-round">
                    <i class="ri-share-forward-line"></i>
                </button>
            </div>
        </div>
        <div id="mainLiveHomePlaylistResults" class="pa-1"></div>
    `);

    $('#playlistCurrentTitleValue').html(userData.playlists[playlistId].title);

    let api = '/contents?option=saved';
    if (playlistId != 0) {
        api += '&playlist_id=' + playlistId;
        $('.playlistOptionMainDropdown').show();
    } else {
        $('.playlistOptionMainDropdown').hide();
    }

    if (userData.playlists[playlistId].id_parent) {
        $('#playlistOptionMainDropdown-edit').hide();
    } else {
        $('#playlistOptionMainDropdown-edit').show();
    }

    getLiveInLive2(URL_API2 + api + '&page=1&position=All', "#mainLiveHomePlaylistResults");
}


function openPlaylistSettings(){
    $('#modal-body-generic').html(`
        <div class="mod-custom-option" id="playlistOptionMainDropdown-share" onclick="managePrivacyPlaylist('share');">
            <i class="ri-share-forward-line"></i> ${translate('SHARE')}
        </div>
        <div class="mod-custom-option" id="playlistOptionMainDropdown-private" onclick="managePrivacyPlaylist('private');">
            <i class="ri-lock-line"></i> ${translate('MAKE_IT_PRIVATE')}
        </div>
        <div class="mod-custom-option" id="playlistOptionMainDropdown-edit" onclick="editCurrentPlaylist();">
            ${translate('EDIT')}
        </div>
        <div class="mod-custom-option" onclick="deleteCurrentPlaylist();">
            ${translate('DELETE')}
        </div>
       `);

        if(userData.playlists[currentPlaylistId].public == true){
            $('#playlistOptionMainDropdown-share').hide();
            $('#playlistOptionMainDropdown-private').show();
            $('#playlist-sharenow-btn').show();
        }else{
            $('#playlistOptionMainDropdown-share').show();
            $('#playlistOptionMainDropdown-private').hide();
            $('#playlist-sharenow-btn').hide();
        }
    
        BSLight.ModalShow('#modal-generic');
        addPageToState('modal-generic');
}

function editCurrentPlaylist(){
    initCreatePlaylist(currentPlaylistId);
}

var returnToPlaylist = false;
function initCreatePlaylist(idPlaylist=null, returnToPlaylist=false) {

    var title = '';
    var translatedAction = 'CREATE';
    if(idPlaylist){
        title = userData.playlists[idPlaylist].title;
        translatedAction = 'EDIT';
    }

    // Invio = conferma (il campo non sta in un form)
    $('#modal-body-generic-sub').html(`
        <div class="pa-2 ty-pl-form">
            <h3 class="ty-pl-form-title white">${idPlaylist ? translate('EDIT') : translate('CREATE_NEW_PLAYLIST')}</h3>
            <div class="form-group mt-3">
                <input type="text" name="title" class="form-control" value="${title}" id="titlePlaylist" placeholder="${translate('TITLE')}" required autofocus
                    onkeydown="if(event.key === 'Enter'){ event.preventDefault(); $('#createPlaylistButtonAction').trigger('click'); }">
                <label for="titlePlaylist" class="form-label">${translate('TITLE')}</label>
            </div>

            <div class="text-right">
                <button class="button-primary mt-1" id="createPlaylistButtonAction" onclick="managePlaylist(${idPlaylist}, ${returnToPlaylist});">${translate(translatedAction)}</button> 
            </div>
        </div>
    `);

    BSLight.ModalShow('#modal-generic-sub');
    addPageToState('modal-generic-sub');
}

function managePlaylist(idPlaylist = null, returnToPlaylist=false) {
    var titlePlaylist;

    saveSpinnerState('#createPlaylistButtonAction',false);

    var method = 'POST';
    var stringPlaylistId = '';
    if(idPlaylist){
        method = 'PATCH';
        stringPlaylistId = '/'+idPlaylist;
    }

    if ($('#titlePlaylist').val()) {
        titlePlaylist = $('#titlePlaylist').val();
    } else {
        titlePlaylist = translate('MY_PLAYLIST');
    }

    let dataString = 'title=' + titlePlaylist;
    $.ajax({
        type: method,
        url: URL_API2 + '/playlists'+stringPlaylistId,
        data: dataString,
        async: true,
        success: function (json) {
            json = JSON.parse(json);

            checkGeneralCurrentState();

            if(idPlaylist){
                userData.playlists[idPlaylist].title = titlePlaylist;
            }else{
                userData.playlists[json.id] = {
                    title: titlePlaylist,
                    image: 'https://teyuto.tv/imgs/generateGradient?value='+titlePlaylist,
                    public: false,
                    collections: [],
                    videos: [],
                };
            }
          
            if (returnToPlaylist) {
                openModalSetSavedContent(lastIdContentPlaylistToSave, lastTypeContentPlaylistToSave, true);
            }else{
                if(idPlaylist){
                    //edit playlist: aggiorna titolo inline e label della tab
                    $('#playlistCurrentTitleValue').html(titlePlaylist);
                    $('#playlist-tab-'+idPlaylist).html(titlePlaylist);
                }else{
                    initPlaylistSection(json.id);
                }
            }
        }
    });
}

function deleteCurrentPlaylist(){
    $.ajax({
        type: 'DELETE',
        url: URL_API2 + '/playlists/'+currentPlaylistId,
        async: true,
        success: function (json) {
            initPlaylistSection();
            delete userData.playlists[currentPlaylistId];
            open_notifications_toast(
                translate('DELETED'),
                'rgba(0, 194, 59, 0.8)'
            );
        }
    });
}

// Shim di compatibilità: le playlist ora vivono come TAB dentro la pagina
// Salvati (niente più pagina playlistview dedicata). Resta per i call site
// esterni e per il back sui vecchi layer 'playlist-<id>'.
function getPlaylistContents(playlistId = 0){
    navigateToPage('saved');
    initPlaylistSection(playlistId);
    setFirebaseAnalyticsPage("playlist");
}

function managePrivacyPlaylist(privacy){
    if(privacy == 'share'){
        saveSpinnerState('#playlistOptionMainDropdown-share',false);
        $.ajax({
            url: `${URL_API2}/playlists/${currentPlaylistId}`,
            type: 'PATCH',
            contentType: 'application/x-www-form-urlencoded',
            data: `public=true`,
            success: function() {
                saveSpinnerState('#playlistOptionMainDropdown-share',true);
                $('#playlistOptionMainDropdown-share').hide();
                $('#playlistOptionMainDropdown-private').show();
                $('#playlist-sharenow-btn').show();
                userData.playlists[currentPlaylistId].public = true;
                shareNowPlaylist();
            },
            error: function(xhr, status, error) {
                console.error('Error updating data:', error);
            }
        });
        
    }else{
        saveSpinnerState('#playlistOptionMainDropdown-private',false);
        $.ajax({
            url: `${URL_API2}/playlists/${currentPlaylistId}`,
            type: 'PATCH',
            contentType: 'application/x-www-form-urlencoded',
            data: `public=false`,
            success: function() {
                //scambio solo i bottoni
                saveSpinnerState('#playlistOptionMainDropdown-private',true);
                $('#playlistOptionMainDropdown-share').show();
                $('#playlistOptionMainDropdown-private').hide();
                $('#playlist-sharenow-btn').hide();
                userData.playlists[currentPlaylistId].public = false;
            },
            error: function(xhr, status, error) {
                console.error('Error updating data:', error);
            }
        });
    }
}

function shareNowPlaylist(){
    shareThisElement('playlist', currentPlaylistId);
}
/* ------------------------------------------------------------------ *
 * Pagina playlist CONDIVISA (/playlist?id=X) — vista pubblica, anche
 * da guest. Render nella pagina reale .pageMob-playlistview; layer di
 * navigazione 'playlist-<id>' (URL SEO /playlist?id=<id> sul web).
 * ------------------------------------------------------------------ */

// translate con fallback esplicito (chiave assente => testo dato)
function tyPlTr(key, fallback) {
    var v = translate(key);
    return (v && v !== key) ? v : fallback;
}

function openSharedPlaylist(id) {
    Nav.push('playlist-' + id);
    // pagina contenuto reale: navigateToPage non tocca la history
    navigateToPage('playlistview');

    var $c = $('.pageMob-playlistview .playlistview-content');
    $c.html('<div id="loading_results_spinner" class="col-md-12 text-center row" style="margin-top:35vh;"><svg class="circularLoading" height="50" width="50"><circle class="path" cx="25" cy="25.2" r="19.9" fill="none" stroke-width="6" stroke-miterlimit="10" /></svg></div>');

    $.ajax({
        localCache: true,
        cacheTTL: 0.5,
        type: 'GET',
        url: URL_API2 + '/playlists/' + id,
        success: function (json) {
            var playlist = JSON.parse(json);
            var idReal = playlist.id_parent ? playlist.id_parent : playlist.id;
            var author = playlist.user || {};
            var img = playlist.image || '';

            $c.html(`
                <div class="plpage">
                    <div class="plpage-hero">
                        ${img ? `<div class="plpage-backdrop" style="background-image:url('${img}')"></div>` : ''}
                        <div class="plpage-hero-inner">
                            <div class="plpage-cover">
                                ${img ? `<img src="${img}" onerror="this.parentNode.innerHTML='<i class=\'ri-play-list-2-line\'></i>';">` : `<i class="ri-play-list-2-line"></i>`}
                            </div>
                            <div class="plpage-meta">
                                <p class="plpage-kicker">${tyPlTr('PLAYLIST', 'Playlist')}</p>
                                <h1 class="plpage-title white xbold">${(playlist.title || '')}</h1>
                                <div class="plpage-author">
                                    ${author.image ? `<img src="${author.image}" onerror="this.style.display='none'">` : ''}
                                    <span>${author.display_name || ''}</span>
                                    <span class="plpage-dot">&bull;</span>
                                    <span>${playlist.total_contents || 0} ${tyPlTr('CONTENTS', 'contenuti')}</span>
                                </div>
                                <div class="plpage-actions">
                                    ${(playlist.first_content && playlist.first_content.id) ? `<button class="button-primary" onclick="startFirstContentPlaylist('${playlist.first_content.id}','${playlist.first_content.type}');"><i class="ri-play-fill"></i> ${tyPlTr('PLAY_ALL', 'Riproduci tutto')}</button>` : ''}
                                    <button class="button-round" onclick="shareThisElement('playlist', ${idReal});"><i class="ri-share-forward-line"></i></button>
                                    <button style="display:none;" id="plpageSaveBtn" class="button-round" onclick="savePagePlaylist('${idReal}');"><i class="ri-bookmark-line"></i></button>
                                    <button style="display:none;" id="plpageUnsaveBtn" class="button-round" onclick="removeSavedPagePlaylist('${playlist.id}');"><i class="ri-bookmark-fill"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="playlistPageContents" class="plpage-contents"></div>
                </div>
            `);

            // salva/rimuovi: solo per chi NON è il proprietario (guest: salva
            // → flusso registrazione dentro savePagePlaylist)
            var plChecks = 0;
            var plTimer = setInterval(function () {
                if (typeof userData !== 'undefined' && userData && userData.status !== undefined) {
                    clearInterval(plTimer);
                    if (userData.status == 'success') {
                        if (userData.id_user != (author.id)) {
                            if (userData.playlists && userData.playlists[playlist.id]) {
                                $('#plpageUnsaveBtn').show();
                            } else {
                                $('#plpageSaveBtn').show();
                            }
                        }
                    } else {
                        $('#plpageSaveBtn').show();
                    }
                } else if (++plChecks > 100) { clearInterval(plTimer); }
            }, 100);

            getLiveInLive2(URL_API2 + '/contents?option=saved&playlist_id=' + id + '&page=1&position=All', '#playlistPageContents');
        },
        error: function (jqXHR, textStatus) {
            if (textStatus === 'abort') { return; }
            // playlist inesistente/privata: si torna indietro
            try { Nav.backIf('playlist-'); } catch (e) {}
            try { window.plugins.toast.showShortBottom(tyPlTr('NO_RESULTS', 'Playlist non disponibile')); } catch (e) {}
        }
    });
}

function startFirstContentPlaylist(id, type) {
    if (type == 'serie') {
        openSerieThumb(id);
    } else if (type == 'video') {
        loadPageVideo(id);
    }
}

function savePagePlaylist(id) {
    if (typeof userData === 'undefined' || !userData || userData.status != 'success') {
        openModalLogin(true);
        return;
    }
    $.ajax({
        type: 'POST',
        url: URL_API2 + '/playlists/' + id,
        async: true,
        success: function (json) {
            try {
                json = JSON.parse(json);
                userData.playlists[json.id] = json;
            } catch (e) {}
            try { window.plugins.toast.showShortBottom(translate('SAVED')); } catch (e) {}
            $('#plpageSaveBtn').hide();
            $('#plpageUnsaveBtn').show();
        }
    });
}

function removeSavedPagePlaylist(id) {
    $.ajax({
        type: 'DELETE',
        url: URL_API2 + '/playlists/' + id,
        async: true,
        success: function () {
            try { delete userData.playlists[id]; } catch (e) {}
            try { window.plugins.toast.showShortBottom(translate('DELETED')); } catch (e) {}
            $('#plpageUnsaveBtn').hide();
            $('#plpageSaveBtn').show();
        }
    });
}
